module.exports = __webpack_public_path__ + "img/minexLogo.465d1f22.svg";